var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeople1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41797 7.83658C7.41797 10.5077 9.58338 12.6732 12.2545 12.6732C14.9257 12.6732 17.0911 10.5077 17.0911 7.83658C17.0911 5.16541 14.9257 3 12.2545 3C9.58338 3 7.41797 5.16541 7.41797 7.83658Z",
    fill: "#00685F",
    stroke: "#00685F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 20.1374C11.7712 22.5558 17.4945 21.1451 19.5097 20.1374C19.5097 17.7191 16.4869 15.3008 12.2549 15.3008C6.81372 15.3008 5 18.3236 5 20.1374Z",
    fill: "#00685F",
    stroke: "#00685F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople1);
export default __webpack_public_path__ + "static/media/People 1.2502f83226d3a2c9dc76d8ad4ac6630b.svg";
export { ForwardRef as ReactComponent };